import React from "react";
import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
} from "@mui/x-data-grid";
import { Button, ButtonGroup } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import HandymanIcon from "@mui/icons-material/Handyman";
import VisibilityIcon from "@mui/icons-material/Visibility";
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import TagIcon from '@mui/icons-material/Tag';
import AllInclusiveIcon from "@mui/icons-material/AllInclusive";
import visibilityStates from "./visibilityStates.ts";
import AssessmentIcon from '@mui/icons-material/Assessment';

interface ToolbarProps {
  handleBulkAction: (action: string) => void;
  handleVisibilityChange: (stateName: keyof typeof visibilityStates) => void;
  openReportOverlay: () => void;
  openBulkActionOverlay: () => void;
}

const Toolbar: React.FC<ToolbarProps> = ({ handleBulkAction, handleVisibilityChange, openReportOverlay, openBulkActionOverlay }) => {


  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  const buttonStyle = {
    sx: {
      color: isDarkMode ? "#00FFFF" : "inherit",
      textTransform: "none",
    },
  };

  return (
    <GridToolbarContainer>
      <GridToolbarExport slotProps={{ button: buttonStyle }} />
      <GridToolbarColumnsButton slotProps={{ button: buttonStyle }} />
      <GridToolbarDensitySelector slotProps={{ button: buttonStyle }} />

      <ButtonGroup variant="text" size="small" sx={{ ml: 2 }}>
        <Button
          onClick={() => handleVisibilityChange("default")}
          startIcon={<AllInclusiveIcon />}
          sx={buttonStyle.sx}
        >
          All
        </Button>
        <Button
          onClick={() => handleVisibilityChange("minimal")}
          startIcon={<VisibilityIcon />}
          sx={buttonStyle.sx}
        >
          Oversight
        </Button>
        <Button
          onClick={() => handleVisibilityChange("operational")}
          startIcon={<TagIcon />}
          sx={buttonStyle.sx}
        >
          Post Work
        </Button>
        <Button
          onClick={() => handleVisibilityChange("setUp")}
          startIcon={<SettingsSuggestIcon />}
          sx={buttonStyle.sx}
        >
          Bus Breakdown
        </Button>
      </ButtonGroup>

      <Button
        onClick={openBulkActionOverlay}
        variant="text"
        size="small"
        color="primary"
        startIcon={<HandymanIcon />}
        sx={buttonStyle.sx}
      >
        BULK ACTION
      </Button>
      <Button
        onClick={openReportOverlay}
        variant="text"
        size="small"
        color="secondary"
        startIcon={<AssessmentIcon />}
        sx={buttonStyle.sx}
      >
        Write Pier Report
      </Button>
    </GridToolbarContainer>
  );
};

export default Toolbar;
